/**
 * Base class for medias extractors : Photo, Background, Sticker
 * Loads files, extract image (HTMLImage) , thumb (base64) and original size and wanted size (ratio)
 */
 fx.ns("shared", class MediaExtractor extends fx.EventDispatcher {

    /**
     * parameters :
     * - data : array of object Files
     * - [optional] thumbSize : size of extracted thumb (base64). Default value : 300
     * - [optional] imageMaxSize : max original size for image. Default value : 5000
     * @param {Object} parameters 
     */
    constructor(parameters)
    {
        super();

        this.data = (parameters && parameters.data) ? parameters.data : null;
        this._thumbSize = (parameters && parameters.thumbSize) ? parameters.thumbSize : 300;
        this._PICTURE_MAX_SIZE = (parameters && parameters.imageMaxSize) ? parameters.imageMaxSize : 5000;

        this._queueFiles = [];
        this._processedFiles = [];

        this._currentFile = {};
        
        this._imageLoadedHandler = this._onImageLoaded.bind(this);
    }

    get thumbSize()
    {
        return this._thumbSize;
    }

    set thumbSize(val)
    {
        this._thumbSize = val;
    }

    get queueFiles()
    {
        return this._queueFiles;
    }

    get processing()
    {
        return this._queueFiles.length > 0;
    }

    /*get allFiles()
    {
        return this._queueFiles.concat( this._processedFiles )
    }*/

    get noRevoke()
    {
        return this._processedFiles.length <= fx.get("settings").noRevokePictures; // don't revoke pictures under 1000
    }

    /**
    * Call this function with array of files to be processed asynchronously
    * @param {Array} files 
    */
    process(files)
    {
        this._queueFiles = this._queueFiles.concat( files );

        this.processStarting();
        this._processQueue();
    }

    /**
     * Override this function to get each extracted data for each file.
     * Extract data object contains the following properties :
     * - thumb : base64 code corresponding to thumb
     * - width : original image width
     * - height : original image height
     * - orientation : orientation angle
     * - date : date when image was created
     * - file : original File object
     * - image : HTML Image containing image file
     * @param {Object} data 
     */
    onImageExtracted(data)
    {
       
    }

    /** To Override in order to do stuff before process starting */
    processStarting()
    {
        
    }

    /** To Override in order to do stuff after process finishes */
    processFinished()
    {
        this._processedFiles = [];
    }

    get total()
    {
        return this._processedFiles.length + this._queueFiles.length;
    }

    get position()
    {
        return this._processedFiles.length;
    }

    // ------------------------------ PRIVATE ----------------------- //

    _processQueue()
    {
        if (this._queueFiles.length == 0)
        {
            this._currentFile = {};
            this.processFinished();
            return;
        }

        if ( (this._currentFile && this._currentFile.processing))
            return;

        this._currentFile.file = this._queueFiles.shift();
        this._processedFiles.push(this._currentFile.file);
        this._currentFile.processing = true;

        if (this._currentFile.file.name.toLowerCase().endsWith(".heic"))
        //if (this._currentFile.isHeic)
        {
            this._manageHeic();
        }
        else
        {
            try
            {
                let loadingImage = loadImage(   this._currentFile.file, 
                                                this._imageLoadedHandler, 
                                                {
                                                    maxWidth: 1000,
                                                    maxHeight: 1000,
                                                    downsamplingRatio:0.7,
                                                    orientation:true,
                                                    meta:true,
                                                    noRevoke : this.noRevoke
                                                }
                                            );
                
                if (!loadingImage)
                    this._nextFile();
            } 
            catch(e)
            {
                this._nextFile();
            }
        }
    }

    _manageHeic()
    {
        /*this._temporaryImage = new Image();
        this._temporaryImage.onload = this._imageLoadedHandler;
        this._temporaryImage.src = fx.assets.imagePlaceHolder.content;*/


        this.onImageExtracted( {
            thumb : fx.assets.imagePlaceHolder.content,
            width : 1000,
            height : 1000,
            orientation : 0,
            date : this._currentFile.file.lastModifiedDate,
            file : this._currentFile.file,
            image : null,
            luminance : 0,
            thumbWidth : 150,
            thumbHeight : 150
        });


        this._nextFile();
    }

    _onImageLoaded(img, data)
    {
        /*if (this._temporaryImage)
        {
            img = this._temporaryImage;
            data = {originalWidth : img.width, originalHeight : img.height, date : this._currentFile.file.lastModifiedDate}
            this._temporaryImage = null;
        }*/

        if (!img || img.type === "error")
        {
            this._nextFile();
            return;
        }

        try {            
            
            let newWidth, newHeight;

            if (img.height > img.width)
            {
                newHeight = this.thumbSize;
                newWidth = newHeight * img.width / img.height;
            }
            else
            {
                newWidth = this.thumbSize;
                newHeight = newWidth * img.height / img.width;
            }

            let dataImg = fx.graphics.imageToDataUri(img, newWidth, newHeight, this._currentFile.file.type); 
            let luminance = fx.graphics.getImageLuminance(img, newWidth, newHeight);
            
            let widthOriginal = Math.min(data.originalWidth, this._PICTURE_MAX_SIZE);
            let heightOriginal = Math.min(data.originalHeight, this._PICTURE_MAX_SIZE);

            
            if (data.originalWidth > data.originalHeight)
                heightOriginal = widthOriginal * img.height / img.width;
            else
                widthOriginal = heightOriginal * img.width / img.height;

            this.onImageExtracted( {
                                    thumb : dataImg,
                                    width : widthOriginal,
                                    height : heightOriginal,
                                    orientation : (img.errorRotate ? 0 : Exif.getOrientationAngle(data.exif)),
                                    date : (data.date || Exif.getDateTaken(data.exif) ||  new Date() ),
                                    file : this._currentFile.file,
                                    image : img,
                                    blob : this.noRevoke ? img.src : "",
                                    luminance : luminance,
                                    thumbWidth : newWidth,
                                    thumbHeight : newHeight,
                                    latitude: Exif.getCoordinates(data.exif).latitude,
                                    longitude: Exif.getCoordinates(data.exif).longitude
                                });
            
            
            this._nextFile();

        }
        catch(e)
        {
            this._nextFile();
        }
    }

    _nextFile()
    {
        if (this._currentFile)
            this._currentFile.processing = false;

        this.delay(this._processQueue);
    }


});